export default __webpack_public_path__ + "static/media/discord-icon.6c0ca1aa.svg";